import { Box } from "@mui/material";
import { visuallyHiddenSx } from "@gui/widgets/A11y";
import type { PageAction } from "./PageLayout.types";

/**
 * A live region is only read when its content changes, so it is mounted for as long as the action
 * could become busy and filled when it does. It must sit outside any menu: a menu item is gone
 * the moment its menu closes, and picking the item is what closes it.
 */
export function BusyAnnouncement(props: { action: Pick<PageAction, "busy" | "busyLabel"> }) {
	if (props.action.busyLabel === undefined) return null;
	return (
		<Box component="span" role="status" sx={visuallyHiddenSx}>
			{props.action.busy ? props.action.busyLabel : ""}
		</Box>
	);
}
